import { z } from "zod";

export const RegisterSchema = z
  .object({
    name: z
      .string()
      .min(2, "Please Enter your Name")
      .regex(/^[a-zA-Z\s]+$/, "Name must only contain alphabets and spaces."),
    phone_no: z
      .string()
      .trim()
      .min(10, "Phone number must be 10 digits")
      .max(10, "Phone number must be 10 digits")
      .regex(/^[6-9]\d{9}$/, "Invalid phone number"),
    whatsapp_number: z
      .string()
      .trim()
      .min(10, "Whatsapp number must be 10 digits")
      .max(10, "Whatsapp number must be 10 digits")
      .regex(/^[6-9]\d{9}$/, "Invalid phone number")
      .optional(),
    email: z.string("Enter a valid Email Address").email(),
    education_qualification: z.string().min(3, "Education Qualification is Required"),
    other_qualification: z.string().optional(),
    state: z.string().min(2, "Enter Your State"),
    district: z.string().min(2, "Enter your Disctrict"),
    city: z.string().min(2, "Enter Your City/Town"),
    pin: z.string().min(6, "Enter a valid Pin Code"),
  })
  .refine(
    (data) =>
      data.sameAsContact ||
      (data.whatsapp_number && data.whatsapp_number.length === 10),
    {
      message: "WhatsApp number is required if not same as contact number",
      path: ["whatsapp_number"],
    }
  );